module.exports = __webpack_public_path__ + "img/poter1.c6a25750.jpg";